import Drawer from "components/Drawer/index";
import Input from "components/Input/index";
import InputPassword from "components/InputPassword/index";
import Modal from "components/Models/index";
import SelectCountry from "components/SelectCountry/index";
import useScreenMobile from "hooks/useScreen";
import React, { useState, useContext } from "react";

import "./deleteAccount.scss";
import Button from "components/Button/index";
import { DeleteReason } from "constants/setup/countries";
import { ManageUser as MU } from "@induz/sdk";
import { useToast } from "components/Toaster/index";
import { signInContext } from "context/SigninContext";
import { useNavigate } from "react-router-dom";


const DeleteAccountSecurity = ({ handleCancelModel, handleSave }) => {
  return (
    <Modal
      heading="Delete Account"
      showFooter={false}
      handleCancel={handleCancelModel}
    >
      <DeleteAccountContent
        handleCancel={handleCancelModel}
        handleSave={handleSave}
      />
    </Modal>
  );
};

export default DeleteAccountSecurity;

const DeleteAccountContent = ({ handleCancel, handleSave }) => {
  const showToast = useToast();
  const isMobile = useScreenMobile({ size: 992 });
  const navigate = useNavigate();

  const [deleteReason, setDeleteReason] = useState({
    password: "",
    moreDetails: ""
  });
  const [selectedReason, setSelectedReason] = useState(
    "Select reason for leaving"
  );

  const handleReasonSelect = (reason) => {
    setSelectedReason(reason);
  };

  const handleChangePassword = (e) => {
    setDeleteReason((prev) => ({
      ...prev,
      password: e.target.value
    }));
  };

  const handleChangeMoreDetails = (e) => {
    setDeleteReason((prev) => ({
      ...prev,
      moreDetails: e.target.value
    }));
  };
  const [loading, setLoading] = useState(false);
  const { userMail } = useContext(signInContext);

  const onDeleteAccount = async () => {



    try {
      setLoading(true);
      const user = await MU.getUserDetails(userMail);

      if (!user) {
        showToast("User not found", "error");
        return;
      }
      await user.remove(deleteReason.password); // Pass password here if needed

      showToast("Account deleted successfully", "success");
      sessionStorage.removeItem("mail");
      localStorage.removeItem("izauthtoken");
      sessionStorage.removeItem("ysentinal-history"); // Clear log history
      navigate("/signin");

    } catch (e) {
      setLoading(false);
      showToast("Error deleting account", "error");
      console.error("Error deleting account:", e);
    }
  };


  return (
    <section className="container deleteContainer">
      <h5 className="deleteContent">
        All your data will be deleted permanently.

      </h5>
      <div className="passwordContent">
        <p className="passwordLabel">Password</p>
        <InputPassword
          value={deleteReason?.password}
          onChange={handleChangePassword}
          inputWidth={isMobile ? "100%" : "370px"}
        />
      </div>
      <SelectCountry
        label="Reason for leaving"
        selectedCountry={selectedReason}
        data={DeleteReason}
        onSelectCountry={handleReasonSelect}
        width="93%"
      />
      <Input
        label="More details (Optional)"
        placeholder="Add your notes"
        value={deleteReason?.moreDetails}
        onChange={handleChangeMoreDetails}
      />
      <div className="buttonContainer">
        <Button
          title="Cancel"
          type="white"
          width={isMobile ? "40%" : "90px"}
          onClick={handleCancel}
        />
        <Button
          loading={loading}
          title="Delete"
          type="delete"
          width={isMobile ? "40%" : "194px"}
          onClick={onDeleteAccount}
          disabled={
            !deleteReason.password ||
            selectedReason === "Select reason for leaving"
          }
        />
      </div>
    </section>
  );
};
